module.exports = __webpack_public_path__ + "img/winners.ccb51654.svg";